export default {
  title: 'Szczegóły dostawy',
  buttons: {
    save: 'Zapisz',
  },
};
